export const enum ManagerAccountState {
  notActiveCompany,
  notApply,
  applied,
}
export interface Company {
  id: string;
  code: string;
  name: string;
  counselor?: {
    counselorId: string;
    counselorName: string;
  }
  customerService?: {
    customerServiceId: string;
    customerServiceName: string;
  }
  progressState: number;
  amountOfLicense: number;
  amountOfEmployee: number;
  vat: string;
  hrmLicense?: string;
  account: string;
  feature: {
    enableFacePass: boolean;
    enableClockIn: boolean;
    enableStayFun: boolean;
    enablePY: boolean;
  }
  isFinished: boolean;
  isStartUp: boolean;
  jobTitles: string[];
  managerAccountState: ManagerAccountState;
}

export interface CompaniesResponse {
  totalCount: number;
  disabledCount: number;
  enabledCount: number;
  limit: number;
  offset: number;
  companies: Company[];
}
export interface CompanyRequest {
  id?: string;
  code: string;
  name: string;
  counselorId: string;
  customerServiceId: string;
  amountOfLicense: number;
  vat: string;
  account: string;
  enablePY: boolean;
  enableFacePass: boolean;
  enableClockIn: boolean;
  enableStayFun: boolean;
  progressState: number;
}
